var $8bb10b4d3226212a$exports = {};
$8bb10b4d3226212a$exports = {
    "valid": `\u{414}\u{435}\u{439}\u{441}\u{442}\u{432}\u{438}\u{442}\u{435}\u{43B}\u{44C}\u{43D}\u{44B}\u{439}`
};


export {$8bb10b4d3226212a$exports as default};
//# sourceMappingURL=ru-RU.mjs.map
